// removed by extract-text-webpack-plugin
module.exports = {"Slider":"Gallery__Slider--2eQB_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Gallery/Gallery.scss
// module id = 404
// module chunks = 0